import { useState } from 'react'
import { useWebView } from 'modules/web-view'
import { WebViewPostMessageType } from '@types'

export function useRegisterToken(w = window) {
  const [open, setOpen] = useState(false)
  const { isAppWebView, sendMessage } = useWebView()

  function listener() {
    w.addEventListener('message', (event: MessageEvent) => {
      if (event.data.source === 'app-tino' && isAppWebView) {
        setOpen(
          event.data.type === WebViewPostMessageType.REQUEST_NOTIFICATION_TOKEN
        )
      }
    })
  }

  function submit(accepted: boolean) {
    sendMessage({
      type: WebViewPostMessageType.REGISTER_NOTIFICATION_TOKEN,
      data: { accepted },
    })
    setOpen(false)
  }

  return {
    listener,
    submit,
    open,
    setOpen,
  }
}
